// extracted by mini-css-extract-plugin
export var parcelRow = "_sq-0";